/**
 * AlmadarPostAgenticSearchSLAlmadarPostAgenticSearchSLPage
 *
 * Page component for AlmadarPostAgenticSearchSLAlmadarPostAgenticSearchSLPage
 * Path: /sl/blog/agentic-search
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostAgenticSearchSLPostPageView as __AlmadarPostAgenticSearchSLPostPageView } from '@/components/traits/AlmadarPostAgenticSearchSLPostPageView';
import { AlmadarPostAgenticSearchSLPostAnalyticsView as __AlmadarPostAgenticSearchSLPostAnalyticsView } from '@/components/traits/AlmadarPostAgenticSearchSLPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostAgenticSearchSLAlmadarPostAgenticSearchSLPageProps {
  // Add any page-level props here
}

export function AlmadarPostAgenticSearchSLAlmadarPostAgenticSearchSLPage(_props: AlmadarPostAgenticSearchSLAlmadarPostAgenticSearchSLPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostAgenticSearchSLPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostAgenticSearchSLPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostAgenticSearchSLAlmadarPostAgenticSearchSLPage;
